import { render, staticRenderFns } from "./DataQualityMgmtPanel.vue?vue&type=template&id=ba76168c&scoped=true"
import script from "./DataQualityMgmtPanel.vue?vue&type=script&lang=js"
export * from "./DataQualityMgmtPanel.vue?vue&type=script&lang=js"
import style0 from "./DataQualityMgmtPanel.vue?vue&type=style&index=0&id=ba76168c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba76168c",
  null
  
)

export default component.exports